export default __webpack_public_path__ + "static/media/page-flip-03.454fa11a.mp3";